import { apiWithkey } from "../axios";
import { baseApiURL, catalogApi } from "../endpoints";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";
import { categoryNameTranslate, planPaymentType } from "../../utils/constants";
import DatadogErrorReporter from "../../utils/datadogErrorReporter";
import CatalogError from "../../utils/customErrors/catalogError";
import { tagSemPlanos, tagPlanosDisponiveis } from "../../utils/sendTag";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const getCatalog = async (props) => {
  setLoadingMessage();
  const params = new URLSearchParams(props).toString();
  const url = new URL(`${baseApiURL}${catalogApi}?${params}`);

  return apiWithkey
    .get(url.href)
    .then(async (response) => {
      const { data, status } = response.data;

      if (DatadogErrorReporter.isErrorCode(status)) {
        DatadogErrorReporter.reportApiError(
          new CatalogError(response.data, url, props),
        );
      }

      const consorcioData = useConsorcioStore.getState();

      if (window) {
        tagPlanosDisponiveis();

        window.planos_disponiveis = data
          .map((plano) => {
            return plano.planosTipos.map((tipo) => ({
              plano_id: String(tipo.planoID),
              bem_id: String(tipo.bemId),
              bem_nome: tipo.name,
              produto_categoria:
                categoryNameTranslate[plano.bemCategoriaCodigo],
              valor_credito: plano.bemValor,
              plano_meses: plano.planoMeses,
              grupo: tipo.grupo,
              taxa_total: tipo.planoTaxaAdmTotal,
              valor_parcela: tipo.valorParcela,
              valor_primeira_parcela: tipo.valorParcelaPrimeiroPagto,
            }));
          })
          .flat();
      }

      if (data.length) {
        data.push({
          planoCardType: "simular-novamente",
          bemCredito: 0,
          planoMeses: 0,
          planosTipos: [
            {
              planoID: 0,
            },
          ],
        });

        useConsorcioStore.setState({
          ...consorcioData,
          fetchedPlans: data,
        });

        await sleepAwait(fakeLoad);

        const { resumePlansTargetStep } = useBotControlStore.getState();

        if (resumePlansTargetStep) {
          useBotControlStore.setState({
            skipStepTracking: true,
            skipStepAction: true,
            currentStep: findStep(resumePlansTargetStep).index,
            resumePlansTargetStep: null,
          });
        } else {
          useBotControlStore.setState({
            currentStep: findStep("selecao_planos").index,
          });
        }
      }
    })
    .catch((error) => {
      useBotControlStore.setState({ resumePlansTargetStep: null });
      DatadogErrorReporter.reportApiError(new CatalogError(error, url, props));
      if (error?.response?.data?.validationErrors) {
        if (
          error.response.data.validationErrors[0][0].message ===
          "Nenhum plano encontrado para essa faixa de renda."
        ) {
          useBotControlStore.setState({
            currentStep: findStep("erro_renda_insuficiente").index,
          });
          tagSemPlanos(
            error.response.data.validationErrors[0][0].code,
            error.response.data.validationErrors[0][0].message,
          );
          return;
        }

        if (
          error.response.data.validationErrors[0][0].message ===
          "Nenhum plano encontrado para essa faixa de credito."
        ) {
          useBotControlStore.setState({
            currentStep: findStep("erro_sem_planos").index,
          });
          useUserStore.setState({
            isSimulateAgain: true,
          });
          tagSemPlanos(
            error.response.data.validationErrors[0][0].code,
            error.response.data.validationErrors[0][0].message,
          );
          return;
        }
      }

      tagSemPlanos(0, "Erro desconhecido ao buscar catálogo de planos.");

      useBotControlStore.setState({
        currentStep: findStep("erro_geral").index,
      });
    })
    .finally(() => {
      removeLoadingMessage();
    });
};

export { getCatalog };
